import { createContext } from 'react';
import utils from 'utils';

type EnquiryContextProps = {
  onEnquire: (listingId: string) => void;
  closeModal: () => void;
};

export default createContext<Partial<EnquiryContextProps>>({
  onEnquire: utils.noop,
  closeModal: utils.noop,
});
